<form [formGroup]="selectForm" class="center-align">
  <item-select *ngIf="showGrade"
               [roles]="roles"
               label="Select School Grade"
               i18n-label="User Profile|School grade select input label@@user-profile-school-grade-select-input-label"
               [disabled]="!allowGradeSelect"
               [compareWith]="compareGrades"
               [displayWith]="displayGrade"
               [loadWith]="loadGrades"
               [selectedItem]="selectedGradeEx"
               (selected)="handleGradeSelected($event)"></item-select>

  <item-select *ngIf="showRegion"
               [roles]="roles"
               label="Select Region"
               i18n-label="User Profile|School region select input label@@user-profile-school-region-select-input-label"
               [disabled]="!allowRegionSelect || (requireGradeSelect && !gradeField.value)"
               [compareWith]="compareRegions"
               [displayWith]="displayRegion"
               [loadWith]="loadRegions"
               [selectedItem]="selectedRegion"
               (selected)="handleRegionSelected($event)"></item-select>

  <item-select *ngIf="showSchool && showSchoolType"
               [roles]="roles"
               label="Select School Type"
               i18n-label="User Profile|School type select input label@@user-profile-school-type-select-input-label"
               [disabled]="(!regionField.value || regionField.value.id == '-1') || !allowSchoolTypeSelect"
               [compareWith]="compareTypes"
               [displayWith]="displayType"
               [loadWith]="loadTypes"
               [selectedItem]="selectedSchoolType"
               (selected)="typeSelected($event)"></item-select>

  <item-autocomplete *ngIf="showSchool" #schoolSearch
                     class="school-select"
                     label="School"
                     i18n-label="User Profile|School query input label@@user-profile-school-query-input-label"
                     placeholder="Start by typing school's name..."
                     i18n-placeholder="User Profile|School query input placeholder@@user-profile-school-query-input-placeholder"
                     [fitText]="true"
                     [required]="schoolRequired"
                     [clearAfterSelect]="clearSchoolAfterSelect"
                     [allowManualClear]="allowSchoolClear"
                     [displayWith]="displaySchool"
                     [searchWith]="searchSchools"
                     (selected)="handleSchoolSelected($event)"
                     (cleared)="handleSchoolClear()"></item-autocomplete>
</form>
